import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCTA() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="bg-gradient-to-b from-slate-900 to-slate-800 text-white py-20 px-4" data-id="element-53">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto text-center" data-id="element-54">
        <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-55">
          Your Dog Deserves Peace. <br data-id="element-56" />
          <span className="text-orange-400" data-id="element-57">You Deserve Freedom.</span>
        </h2>

        <p className="text-xl text-slate-300 mb-10 max-w-2xl mx-auto" data-id="element-58">
          Stop feeling guilty. Stop worrying about complaints. Start living the
          life you both deserve.
        </p>

        <motion.a href="https://floctiva.com/cart/53021114695996:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="bg-gradient-to-b from-orange-400 to-orange-600 hover:from-orange-500 hover:to-orange-700 text-white font-extrabold text-xl md:text-2xl px-12 py-6 rounded-full shadow-[0_10px_40px_rgba(249,115,22,0.5)] inline-flex items-center gap-3 transition-all duration-300 animate-pulse cursor-pointer ring-4 ring-orange-500/30 hover:ring-orange-500/50" data-id="element-59">
          YES! GET INSTANT ACCESS FOR $17
          <ArrowRight className="w-6 h-6" data-id="element-60" />
        </motion.a>

        <p className="text-sm text-slate-400 mt-6" data-id="element-61">
          Instant digital delivery • 60-Day Money Back Guarantee
        </p>
      </motion.div>
    </section>;
}